export const LOAD_CALENDAR_EVENTS = 'events/LOAD_CALENDAR_EVENTS';
export const SHOW_DAILY_EVENT = 'events/SHOW_DAILY_EVENT';
export const SHOW_DETAIL_EVENT = 'events/SHOW_DETAIL_EVENT';
export const HIDE_DETAIL_EVENT = 'events/HIDE_DETAIL_EVENT';
export const GO_TO_TODAY = 'events/GO_TO_TODAY';
